// ======================================================================

$(document).ready(function(){
  $('body').on('click', '.copy-btn', function(e) {
    var copyText = document.getElementById("discount_get");
    copyText.select();
    copyText.setSelectionRange(0, 99999)
    document.execCommand("copy");
    //alert("Copied the text: " + copyText.value);
  })

  $('body').on('click', '.close-size-pop', function(e) {
    $(".product-size.custom-cart-variants").removeClass("activeSizes");

  })

  $('.header-cart-related-list').on('swipe', function(event, slick, direction) {
    $(".product-size.custom-cart-variants").removeClass("activeSizes");

  });
  $('body').on('click', '.header-cart-related-list .slick-next.slick-arrow', function(e) {
    $(".product-size.custom-cart-variants").removeClass("activeSizes");
    //$(".custom-cart-sizes-get").removeClass("active");

  })
  $('body').on('click', '.cart-select-size', function(e) {
    //alert("click");
    $(this).parents(".product-add-size-chrt-box").parents(".product-add-size-chrt-row").parents(".line-item-content").parents(".related-each-item").children(".custom-cart-variants").addClass("activeSizes");

  })
  $('body').on('click', '.product-add-con button', function(e) {
    e.preventDefault();
    var Variantsget = $(this).parents(".product-add-con").attr("data-idget");
    Variantsget = parseInt(Variantsget);
    //alert(Variantsget);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id='+ Variantsget,
      dataType: 'json',
      success: function(data){
        //alert("sucess");
        saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',

          success: function(data) 
          {
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            var countget=$(data).find('.cart_count_items').html();
            $('.cart_count_items').html(countget);
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            $('.header-cart-related-list').slick({
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1
            });
          }
        })
      }
    })	
  })
  $('body').on('click', '.custom-cart-sizes-get', function() {
    var valuereceive = $(this).attr("data-value");
    var varinstId = $(this).attr("data-variId");
    $(this).parents(".custom-cart-variants").next(".line-item-image").children(".line-item-cst-row").children(".line-item-cst-cont").children(".line-item-content").children(".product-add-size-chrt-row").children(".product-add-con").attr("data-idget",varinstId);
    $(this).parents(".custom-cart-variants").next(".line-item-image").children(".line-item-cst-row").children(".line-item-cst-cont").children(".line-item-content").children(".line-item-content-qty-price").children(".slect-size-custom").children(".size-changed").children("span").html(valuereceive);
    $(".product-size.custom-cart-variants").removeClass("activeSizes");
    //.next(".line-item-image").children(".line-item-cst-row").children(".line-item-cst-cont").children(".line-item-content").children(".line-item-content-qty-price").children(".product-add-size-chrt-box").children(".slect-size-custom").children(".size-changed").children("span").html(valuereceive);
    //    $(".product-size.custom-cart-variants").removeClass("activeSizes");
    //     //$(this).parents(".custom-cart-variants").parents(".product-add-size-chrt-row").prev(".line-item-content-qty-price").children(".slect-size-custom").children(".size-changed").children("span").html(valuereceive);
    //     $(this).parents(".custom-cart-variants").next(".cart-select-box").children("option").each(function(){
    //     var getoption =  $(this).val();
    //       if(valuereceive == getoption)
    //     {
    //       var avriantId = $(this).attr("data-val");
    //       alert(avriantId);
    //       //$(this).parents(".cart-select-box").parents(".product-add-size-chrt-box").next(".product-add-con").attr("data-idget",avriantId);
    //     }
    // })

  })
  $('body').on('click', '.custom-cart-icon-box, .custom-mobile-cart', function() {
    $("#overlay").addClass("is-active");
    $(".inline-cart").addClass("is-active");

  })
  $('body').on('click', '.qtyplus', function() {
    var elem = $(this).prev();
    var valuepluss = $(this).attr("max");
    var val_qty = parseInt($(this).prev(".qty").val());
    var getline = $(this).prev(".qty").attr("data-line-item-index");
    getline = parseInt(getline);
    if(val_qty >= 0 &&  val_qty < valuepluss)
    {
      val_qty = val_qty + 1 ;
      $(this).prev(".qty").val(val_qty);
      console.log(val_qty);
    }

    if(elem.attr("data-keys") != undefined) {
      qq = elem.attr("data-quantity").split(",");
              kk = elem.attr("data-keys").split(",");
                              uu = {};
                              for(var i = 0; i < kk.length; i++)
                              {
                                  uu[kk[i]] = qq[i] * elem.val();
                              }
                
                              $.ajax({
                                  type: 'POST',
                                  url: '/cart/update.js',
                                  data: { updates: uu },
                                  dataType: 'json',
                                  success:function(data){
                                      if(data.item_count > 0){
                      $('.cart_count_items').html(data.item_count);          
          
                    } else {
                      $('.cart_count_items').html(data.item_count) ;         
                    }
          
                    $.ajax({
                      type: "GET",
                      url: "/cart",
                      dataType: 'html',
          
                      success: function(data) 
                      {
                        console.log("syncCart");
          
                        // console.log(data);
                        var minicartdata=$(data).filter('#slidingcartmain').html();
                        var countget=$(data).find('.cart_count_items').html();
                        $('.cart_count_items').html(countget);
                        // console.log(minicartdata);
                        $('#slidingcartmain').html(minicartdata);
                        $('.header-cart-related-list').slick({
                          dots: false,
                          slidesToShow: 1,
                          slidesToScroll: 1
                        });
                        $("#overlay").addClass("is-active");
                        $(".inline-cart").addClass("is-active");
                        /* changes - toggle hidden reward & chat widget */
                        $("#admin-bar-iframe").css("display", "none");
                        $("#chat-button").css("display", "none");
                      }
                    })
                                  }
                              });
    } else {
      var last_val = parseInt($(this).prev(".qty").val());
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + last_val + '&line=' + getline,
      dataType: 'json',

      success: function(data) 
      {
        if(data.item_count > 0){
          $('.cart_count_items').html(data.item_count);          

        } else {
          $('.cart_count_items').html(data.item_count) ;         
        }

        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',

          success: function(data) 
          {
            console.log("syncCart");

            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            var countget=$(data).find('.cart_count_items').html();
            $('.cart_count_items').html(countget);
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            $('.header-cart-related-list').slick({
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1
            });
            $("#overlay").addClass("is-active");
            $(".inline-cart").addClass("is-active");
          }
        })
      }
    })
    }
  });

  $('body').on('click', '.qtyminus', function() {
    var valueplus = $(this).attr("min");
    var elem = $(this).next();
    var val_qty = parseInt($(this).next(".qty").val());
    var getline = $(this).next(".qty").attr("data-line-item-index");
    getline = parseInt(getline);
    if(val_qty > 1)
    {
      val_qty = val_qty - 1 ;
      console.log(val_qty);
      $(this).next(".qty").val(val_qty);
    } 

    if(elem.attr("data-keys") != undefined) {
      qq = elem.attr("data-quantity").split(",");
              kk = elem.attr("data-keys").split(",");
              uu = {};
                              for(var i = 0; i < kk.length; i++)
                              {
                                  uu[kk[i]] = qq[i] * elem.val();
                              }
                              $.ajax({
                                  type: 'POST',
                                  url: '/cart/update.js',
                                  data: { updates: uu },
                                  dataType: 'json',
                                  success:function(data){
                                      if(data.item_count > 0){
                      $('.site-header__cart #CartCount').html(data.item_count);          
                    } else {
                      $('.site-header__cart #CartCount').html(data.item_count) ;         
                    }
          
                    $.ajax({
                      type: "GET",
                      url: "/cart",
                      dataType: 'html',
                      success: function(data){
                        console.log(data);
                        // console.log(data);
                        var minicartdata=$(data).filter('#slidingcartmain').html();
                        var countget=$(data).find('.cart_count_items').html();
                        $('.cart_count_items').html(countget);
                        // console.log(minicartdata);
                        $('#slidingcartmain').html(minicartdata);
                        $('.header-cart-related-list').slick({
                          dots: false,
                          slidesToShow: 1,
                          slidesToScroll: 1
                        });
                        $("#overlay").addClass("is-active");
                        $(".inline-cart").addClass("is-active");
                        /* changes - toggle hidden reward & chat widget */
                        $("#admin-bar-iframe").css("display", "none");
                        $("#chat-button").css("display", "none");
                      }
                    })
                                  }
                              });
    } else {
      var last_val = parseInt($(this).next(".qty").val());
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + last_val + '&line=' + getline,
      dataType: 'json',

      success: function(data) 
      {
        if(data.item_count > 0){
          $('.site-header__cart #CartCount').html(data.item_count);          

        } else {
          $('.site-header__cart #CartCount').html(data.item_count) ;         
        }

        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',
          success: function(data){
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            var countget=$(data).find('.cart_count_items').html();
            $('.cart_count_items').html(countget);
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            $('.header-cart-related-list').slick({
              dots: false,
              slidesToShow: 1,
              slidesToScroll: 1
            });
            $("#overlay").addClass("is-active");
            $(".inline-cart").addClass("is-active");
          }
        })
      }
    })
    }
  });


  $(".overlayimg").click(function(){
    $(".main-image").fadeOut();
    $(".overlayimg").fadeOut();
  });

  $(".crossdiv").click(function(){
    $(".main-image").fadeOut();
    $(".overlayimg").fadeOut();
  });

})

// Set the currency to a default based on a landing page
$(document).ready(function(){
  /***************** Product Option Selection and Add to Cart ***********/
  $('body').on('click', '.btn.product-form__cart-submit', function(e){
    var flag_val = false;
    e.preventDefault();
    var size_active =  $(".size-each.active").length;
    var size_error =  $("#size-error").length;
    var buynow = $(this).hasClass("buynow");
    var this_obj = $(this);

    if(this_obj.hasClass('on-bundle')) {
      size_active = size_active/2;
    }

    if(size_active>0.5 || size_error == 0)
    {
      if(this_obj.hasClass('on-bundle')) {
        /*
        var args = [];
          var args_temp = {};
  
          args_temp = {
              quantity: 1,
              id: $('#shoe-variant-id').html()
          };
          args.push(args_temp);
  
          args_temp = {
              quantity: 1,
              id: $('#bag-variant-id').html()
          };
          args.push(args_temp);
  
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { items: args },
            dataType: 'json',
            success: function(response){
              saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
              $.ajax({
                type: "GET",
                url: "/cart",
                dataType: 'html',
                success: function(data){
                  console.log("syncCart");
                  // console.log(data);
                  var countget=$(data).find('.cart_count_items').html();
                  $('.cart_count_items').html(countget);
                  var minicartdata=$(data).filter('#slidingcartmain').html();
                  var countget=$(data).find('.cart_count_items').html();
                  if(countget == 1){
                    $( ".custom-cart-icon-box" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                    $( ".custom-mobile-cart" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                  }
                  else{
                    $('.cart_count_items').html(countget);
                  }
                  if(buynow)
                  {
                    location = "/checkout";
                  }
                  else
                  {
                  // console.log(minicartdata);
                  $('#slidingcartmain').html(minicartdata);
                  $("#size-error").hide();
                  $('.header-cart-related-list').slick({
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  });
                  $("#overlay").addClass("is-active");
                  $(".inline-cart").addClass("is-active");
                  /* changes - toggle hidden reward & chat widget 
                  $("#admin-bar-iframe").css("display", "none");
                  $("#chat-button").css("display", "none");
                  }
                }
              })
            }
          })
          */
      } else {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data:$(".product-form").serialize(),
          dataType: 'json',
          success: function(response){
            saq('ts','4YhCOpGeaPOv705aV-d4Tw', { ecomm_event: 'add_to_cart' });
            $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data){
                console.log("syncCart");
                // console.log(data);
                var countget=$(data).find('.cart_count_items').html();
                $('.cart_count_items').html(countget);
                var minicartdata=$(data).filter('#slidingcartmain').html();
                var countget=$(data).find('.cart_count_items').html();
                if(countget == 1){
                  $( ".custom-cart-icon-box" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                  $( ".custom-mobile-cart" ).prepend( "<span class='cart_count_items'>"+countget+"</span>" );
                }
                else{
                  $('.cart_count_items').html(countget);
                }
                // console.log(minicartdata);
                $('#slidingcartmain').html(minicartdata);
                $("#size-error").hide();
                $('.header-cart-related-list').slick({
                  dots: false,
                  slidesToShow: 1,
                  slidesToScroll: 1
                });
                $("#overlay").addClass("is-active");
                $(".inline-cart").addClass("is-active");
              }
            })
          }
        })
      }
    }
    else{
      if(this_obj.hasClass('on-bundle')) {
          /*
          let error_text = 'Please choose your ';
          if($('.shoe-collection-container').find('.size-each.active').length <= 0) {
            error_text += 'shoe';
          }
          if($('.shoe-collection-container').find('.size-each.active').length <= 0 && $('.bag-collection-container').find('.size-each.active').length <= 0) {
            error_text += ' and ';
          }
          if($('.bag-collection-container').find('.size-each.active').length <= 0) {
            error_text += 'bag';
          } 
          $("#size-error p").html(error_text);
          $("#size-error").show();
          */
      } else {
        $("#size-error").show();
      }
    }
  })
  //   $('body').on('click', '.site-header__cart', function(e){

  //     e.preventDefault();
  //     $("#overlay").addClass("is-active");
  //     $(".inline-cart").addClass("is-active");
  //   })

  $('body').on('click', '.close-cart-img', function(e){
    e.preventDefault();
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
  })

  $('body').on('click', '.continueshopping', function(e){
    
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
  })

  $('body').on('click', '#overlay', function(){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
  })

})

$(document).ready(function(){
  $('body').on('change', '.changequantity', function(){
    var getline = $(this).attr("data-line-item-index");
    var getval = $(this).val();

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:  'quantity=' + getval + '&line=' + getline,
      dataType: 'json',
      success: function(data){
        if(data.item_count > 0){
          $('.site-header__cart #CartCount').html(data.item_count);          
        } else {
          $('.site-header__cart #CartCount').html(data.item_count) ;         
        }

        $.ajax({
          type: "GET",
          url: "/cart",
          dataType: 'html',
          success: function(data){
            console.log("syncCart");
            // console.log(data);
            var minicartdata=$(data).filter('#slidingcartmain').html();
            // console.log(minicartdata);
            $('#slidingcartmain').html(minicartdata);
            $("#overlay").addClass("is-active");
            $(".inline-cart").addClass("is-active");
          }
        })
      }
    })

  })

})

$(document).on("click",".bundle-close",function(e){
  e.preventDefault();
  e.stopPropagation();
  $("#global-loading").addClass("active");
  var elem = $(this);
  elem.parent().slideUp(300,function(){
    group_id = elem.attr("data-id");
    kk = elem.attr("data-keys").split(",");
          uu = {};
          for(var i = 0; i < kk.length; i++)
          {
            uu[kk[i]] = 0;
          }
                        var attributes = {};
      attributes["group:" + group_id] = "";
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates: uu, attributes: attributes },
        dataType: 'json',
        success:function(response){
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cartdata){
              $('.site-header__cart #CartCount').html(cartdata.item_count);
              $.ajax({
                type: "GET",
                url: "/cart",
                dataType: 'html',
                success: function(data) {
                  var countget=$(data).find('.cart_count_items').html();
                  var divLength =$(data).find('.cart_count_items').length;
                  $('.cart_count_items').html(countget);
                  if(divLength==0){
                    $('.cart_count_items').remove();
                  }
                  else{
                    $('.cart_count_items').show();
                  }
                  var minicartdata = $(data).filter('#slidingcartmain').html();
    
                  $('#slidingcartmain').html(minicartdata);
                  $('.header-cart-related-list').slick({
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  });
    
                }
              });
            }
          });
        }
      });
  });
});

function remove(line, quantity){
  $.ajax({
    type: 'POST',
    url: '/cart/change',
    data: 'quantity='+quantity+'&line='+line,
    dataType: 'json',
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cartdata){
          $('.site-header__cart #CartCount').html(cartdata.item_count);
          $.ajax({
            type: "GET",
            url: "/cart",
            dataType: 'html',
            success: function(data) {
              var countget=$(data).find('.cart_count_items').html();
              var divLength =$(data).find('.cart_count_items').length;
              $('.cart_count_items').html(countget);
              if(divLength==0){
                $('.cart_count_items').remove();
              }
              else{
                $('.cart_count_items').show();
              }
              var minicartdata = $(data).filter('#slidingcartmain').html();

              $('#slidingcartmain').html(minicartdata);
              $('.header-cart-related-list').slick({
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
              });

            }
          });
        }
      });
    }
  });
}

$(document).ready(function(){
  $("img.closebar").click(function(){
    $(this).hide();
    $(this).siblings(".promotionaltext.lightboxdisplay").hide();
    $(".home-slideshow.content-width").addClass("pickup");
  })

  $("#AddToCart").click(function(e){
    e.preventDefault();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:$(".product-single__meta .product-form").serialize(),
      dataType: 'json',
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('.site-header__cart #CartCount').html(cartdata.item_count);
            $.ajax({
              type: "GET",
              url: "/cart",
              dataType: 'html',
              success: function(data){
                var countget=$(data).find('.cart_count_items').html();
                $('.cart_count_items').html(countget);
                var minicartdata=$(data).filter('#slidingcartmain').html();
                $('#slidingcartmain').html(minicartdata);
                $("#overlay").addClass("is-active");
                $(".inline-cart").addClass("is-active");
              }
            });
          }

        });
      },
      error: function(resp) {
        var getres = JSON.stringify(resp);
        alert(resp.responseJSON.description);

      }
    });
  })
})
